import { BrowserRouter, Route, Routes } from "react-router-dom"
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgetPassword from "./pages/Forgetpassword";
import Dashborad from "./pages/Dashboard";
import Appview from "./pages/Appview";
import Payment from "./pages/Payment";
import Account from "./pages/Account";



function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login/>}/>
      <Route path="/dashboard" element={<Dashborad/>}/>
      <Route path="/payment" element={<Payment/>}/>
      <Route path="/account" element={<Account/>}/>
      <Route path="/" element={<Appview/>}/>
      <Route path="/signup" element={<Signup/>}/>
      <Route path="/forgetpassword" element={<ForgetPassword/>}/>
      <Route path="/account" element={<Account/>}/>
    </Routes> 
    </BrowserRouter>
   
  );
}

export default App;
